import { Object } from "aws-sdk/clients/s3";
import { THUMB_EXT } from "config";
import { BucketSummary } from "context/bucket/types";
import { filesize } from "filesize";

export const getFileExtension = (fileName: string) =>
  fileName.substring(fileName.lastIndexOf(".") + 1);

export const getSummaryDetails = (contents: Object[]): BucketSummary => {
  let numberOfFiles = 0;
  let dimension = "";
  let size = 0;
  // const folders: BucketFolder[] = [];
  const FOLDER_PATTERN = /\/$/;

  const contentsWithNoThumbExt = contents?.filter(
    ({ Key }) => Key?.substring(Key?.lastIndexOf(".") + 1) !== THUMB_EXT
  );

  contentsWithNoThumbExt?.forEach((entry: Object) => {
    if (entry && entry.Key && entry.Size) {
      size = size + entry.Size;
      if (FOLDER_PATTERN.test(entry.Key)) {
        // const bucketFolder = folderFactory({ Prefix: entry.Key });
        // folders.push(bucketFolder);
      } else {
        numberOfFiles++;
      }
    }
  });

  dimension = filesize(size);
  return { numberOfFiles, dimension };
};

export const toFriendlyExtensionName = (filename: string) => {
  let extension = filename.split(".")?.pop()?.toLowerCase();
  let imageName = "";
  switch (extension) {
    case "jpg":
    case "png":
    case "jpeg":
      imageName = "image";
      break;
    case "pdf":
      imageName = "pdf";
      break;
    case "txt":
    case "odt":
      imageName = "text";
      break;
    case "doc":
    case "docx":
      imageName = "word";
      break;
    case "xls":
    case "xlsx":
      imageName = "excel";
      break;
    case "ods":
      imageName = "calc";
      break;
    default:
      imageName = "document";
      break;
  }
  return imageName;
};
